// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"145":"d7e46320","342":"bf4d59bb","443":"6ced89b0","670":"1497aa84","680":"293b64e3","796":"31d82007"}[chunkId] + ".js";
};